// Registry central de métodos de pago. UI usa esto para logos, colores y flags.
import { Banknote, Landmark, Wallet, Smartphone, ScanLine, Tag, CreditCard } from "lucide-react";

export const PAYMENT_METHODS = {
  EFECTIVO: {
    code: "EFECTIVO", label: "Efectivo", icon: Banknote,
    gradient: "from-emerald-400 to-emerald-600",
    color: "emerald", providerLabel: "",
  },
  TRANSFERENCIA: {
    code: "TRANSFERENCIA", label: "Transferencia", icon: Landmark,
    gradient: "from-sky-400 to-sky-600",
    color: "sky", providerLabel: "Bancaria",
  },
  MERCADO_PAGO: {
    code: "MERCADO_PAGO", label: "Mercado Pago", icon: Wallet,
    gradient: "from-yellow-300 to-yellow-500",
    color: "yellow", providerLabel: "Point",
  },
  TBK_IM30: {
    code: "TBK_IM30", label: "Transbank IM30", icon: ScanLine,
    gradient: "from-violet-400 to-violet-600",
    color: "violet", providerLabel: "POS de kiosco",
  },
  TBK_INTEGRATED: {
    code: "TBK_INTEGRATED", label: "Transbank Integrado", icon: CreditCard,
    gradient: "from-purple-500 to-purple-700",
    color: "purple", providerLabel: "POS caja",
  },
  TBK_SMART: {
    code: "TBK_SMART", label: "Transbank C2C", icon: Smartphone,
    gradient: "from-fuchsia-400 to-fuchsia-600",
    color: "fuchsia", providerLabel: "Cloud to Cloud",
  },
  GEDNET: {
    code: "GEDNET", label: "Gednet", icon: Tag,
    gradient: "from-red-400 to-red-600",
    color: "red", providerLabel: "Recaudación",
  },
  // legacy
  TARJETA: {
    code: "TARJETA", label: "Tarjeta", icon: CreditCard,
    gradient: "from-orange-400 to-orange-600",
    color: "orange", providerLabel: "Débito/Crédito",
  },
};

export function pmMeta(code) {
  if (String(code || "").startsWith("OTRO_")) {
    return { code, label: code, icon: Wallet, gradient: "from-teal-400 to-teal-600", color: "teal", providerLabel: "Medio propio · no integrado" };
  }
  return PAYMENT_METHODS[code] || {
    code, label: code, icon: CreditCard,
    gradient: "from-slate-400 to-slate-700",
    color: "slate", providerLabel: "",
  };
}
